export function buildGameViewMetricsReport(dimensions, components) {
  return {
    ...dimensions,
    components: [...components]
  };
}
